export const apiBaseUrl =
  process.env.API_BASE_URL || 'https://swicms.dev.damncarousel.com/api';
